import React from 'react';
import '../template-file-css/document-file-template.css';


export const PBS_ChildAdolescentDiagnostic = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='PBS_ChildAdolescentDiagnostic' className='file-pdf-document'>
            <div className='file-template w-750'>

                <p className='w-750'>
                    <b>
                        Premier Behavior Services<br />
                        2003 Godwin Avenue-Suite B<br />
                        Lumberton, NC  28358
                    </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Referral Source and Reason for Referral</span>
                    <textarea id='txtReferralSource' name='txtReferralSource' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem/Chief Compliant (as stated by child)</span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family/Guardian/Child Perceptions of Problem/ Stressors/Source of Distress, Onset/Precipitating Events/Symptoms Associated with Problem/ Previous Episodes/Recent Progressions</span>
                    <textarea id='txtDistressSource' name='txtDistressSource' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Client preferences:</span>
                    <textarea id='txtClientPref' name='txtClientPref' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family/ Guardian Preferences:</span>
                    <textarea id='txtFamilyPref' name='txtFamilyPref' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Living Situation</h3></center>
                    <span className='eleHeader'>{`Parent’s Home:`}</span></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParentsHome_Rent' name='cbParentsHome_Rent' className='add-only' value='Rent' />
                            Rent
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParentsHome_Own' name='cbParentsHome_Own' className='add-only' value='Own' />
                            Own
                        </td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>Residential Care/Treatment Facility </span></p>


                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbResidentialTreatment_Hospital' name='cbResidentialTreatment_Hospital' className='add-only' value='Hospital' />
                            Hospital
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbResidentialTreatment_TempHousing' name='cbResidentialTreatment_TempHousing' className='add-only' value='Temporary Housing' />
                            Temporary Housing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbResidentialTreatment_ResidentialCare' name='cbResidentialTreatment_ResidentialCare' className='add-only' value='Residential Care' />
                            Residential Care
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbResidentialTreatment_NursingHome' name='cbResidentialTreatment_NursingHome' className='add-only' value='Nursing Home' />
                            Nursing Home
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Other</span></p>

                <table>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbOther_FriendsHome' name='cbOther_FriendsHome' className='add-only' value='Friends Home' />{'Friend’s Home'}</td>
                        <td className='w-250'> <input type='checkbox' id='cbOther_GuardiansHome' name='cbOther_GuardiansHome' className='add-only' value='Relatives/Guardians Home' />{'Relative’s/Guardian’s Home'}</td>
                        <td className='w-250'> <input type='checkbox' id='cbOther_FosterCare' name='cbOther_FosterCare' className='add-only' value='Foster Care Home' />Foster Care Home</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbOther_Prison' name='cbOther_Prison' className='add-only' value='Jail/Prison' />Jail/Prison</td>
                        <td className='w-250'> <input type='checkbox' id='cbOther_RespiteCare' name='cbOther_RespiteCare' className='add-only' value='Respite Care' />Respite Care</td>
                        <td className='w-250'> <input type='checkbox' id='cbOther_LiveWithFrnd' name='cbOther_LiveWithFrnd' className='add-only' value='Homeless Living with Friend' />Homeless Living with Friend</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbOther_NoResidence' name='cbOther_NoResidence' className='add-only' value='Homeless in Shelter/No Residence' />Homeless in Shelter/No Residence</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbOther_Others' name='cbOther_Others' className='add-only' value='Others' />Others: &nbsp;
                            <input type='text' id='txtOther_Others' name='txtOther_Others' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>{`**Identify Facility or Person’s Name`}</h3></p>
                <p className='w-750'><center><h3>Primary Household</h3></center></p>
                <table>
                    <tr>
                        <td className='w-150'><b>Household Member</b> </td>
                        <td className='w-150'><b>Relationship to Client</b></td>
                        <td className='w-50'><b>Age</b></td>
                        <td className='w-125'><b>Occupation / School</b></td>
                        <td className='w-125'><b>Level of Education</b></td>
                        <td className='w-150'><b>Quality of Relationship</b></td>
                    </tr>


                    <tr>
                        <td className='w-150'><input type='text' id='txtPrimary_HouseHold1' name='txtPrimary_HouseHold1' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_RelClient1' name='txtPrimary_RelClient1' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtPrimary_Age1' name='txtPrimary_Age1' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_School1' name='txtPrimary_School1' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_Education1' name='txtPrimary_Education1' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_Quality1' name='txtPrimary_Quality1' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPrimary_HouseHold2' name='txtPrimary_HouseHold2' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_RelClient2' name='txtPrimary_RelClient2' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtPrimary_Age2' name='txtPrimary_Age2' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_School2' name='txtPrimary_School2' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_Education2' name='txtPrimary_Education2' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_Quality2' name='txtPrimary_Quality2' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPrimary_HouseHold3' name='txtPrimary_HouseHold3' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_RelClient3' name='txtPrimary_RelClient3' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtPrimary_Age3' name='txtPrimary_Age3' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_School3' name='txtPrimary_School3' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_Education3' name='txtPrimary_Education3' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_Quality3' name='txtPrimary_Quality3' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPrimary_HouseHold4' name='txtPrimary_HouseHold4' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_RelClient4' name='txtPrimary_RelClient4' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtPrimary_Age4' name='txtPrimary_Age4' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_School4' name='txtPrimary_School4' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtPrimary_Education4' name='txtPrimary_Education4' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtPrimary_Quality4' name='txtPrimary_Quality4' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'><center><h3>Secondary Household</h3></center>
                    <span className='eleHeader'>Does client live in more than one household? </span></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSecondary_No' name='cbSecondary_No' className='add-only' value='No' />No &nbsp;&nbsp;&nbsp;If no, skip to “Additional Family Members
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSecondary_Yes' name='cbSecondary_Yes' className='add-only' value='Yes' />Yes &nbsp;&nbsp;&nbsp;If yes, complete the secondary household information below
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-150'><b>Household Member</b> </td>
                        <td className='w-150'><b>Relationship to Client</b></td>
                        <td className='w-50'><b>Age</b></td>
                        <td className='w-125'><b>Occupation / School</b></td>
                        <td className='w-125'><b>Level of Education</b></td>
                        <td className='w-150'><b>Quality of Relationship</b></td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSecondary_HouseHold1' name='txtSecondary_HouseHold1' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_RelClient1' name='txtSecondary_RelClient1' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtSecondary_Age1' name='txtSecondary_Age1' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_School1' name='txtSecondary_School1' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_Education1' name='txtSecondary_Education1' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_Quality1' name='txtSecondary_Quality1' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSecondary_HouseHold2' name='txtSecondary_HouseHold2' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_RelClient2' name='txtSecondary_RelClient2' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtSecondary_Age2' name='txtSecondary_Age2' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_School2' name='txtSecondary_School2' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_Education2' name='txtSecondary_Education2' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_Quality2' name='txtSecondary_Quality2' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSecondary_HouseHold3' name='txtSecondary_HouseHold3' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_RelClient3' name='txtSecondary_RelClient3' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtSecondary_Age3' name='txtSecondary_Age3' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_School3' name='txtSecondary_School3' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_Education3' name='txtSecondary_Education3' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_Quality3' name='txtSecondary_Quality3' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtSecondary_HouseHold4' name='txtSecondary_HouseHold4' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_RelClient4' name='txtSecondary_RelClient4' className='add-only w-140 custom-add-only' /></td>
                        <td className='w-50'><input type='text' id='txtSecondary_Age4' name='txtSecondary_Age4' className='add-only w-40 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_School4' name='txtSecondary_School4' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-125'><input type='text' id='txtSecondary_Education4' name='txtSecondary_Education4' className='add-only w-115 custom-add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSecondary_Quality4' name='txtSecondary_Quality4' className='add-only w-140 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Family Members Who Live in Both Households </span></p>
                <table>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbBothHouseHold_OnlyClient' name='cbBothHouseHold_OnlyClient' className='add-only' value='Only Client' />Only Client </td>

                        <td className='w-375'><input type='checkbox' id='cbBothHouseHold_ClientAndList' name='cbBothHouseHold_ClientAndList' className='add-only' value='Client and (list):' />Client and (list):</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtBothHouseHold' name='txtBothHouseHold' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Additional Family Members</span>
                <span className='small'>(i.e., parents or siblings not living in primary or secondary households) </span>
                <table>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbAdditionalMember_No' name='cbAdditionalMember_No' className='add-only' value='No Parents or Siblings Other Than Those Listed in Primary or Secondary Households' />No Parents or Siblings Other Than Those Listed in Primary or Secondary Households</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtAdditionalMember' name='txtAdditionalMember' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Custody and Parenting Plan  </span>
                <table>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbCustody_LiveWithBoth' name='cbCustody_LiveWithBoth' className='add-only' value='Lives with Both Parents (biological or adoptive) in Same Household or with Widowed Parent' />Lives with Both Parents (biological or adoptive) in Same Household or with Widowed Parent </td>

                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbCustody_LegalSole' name='cbCustody_LegalSole' className='add-only' value='Mother or Father has Sole Legal Custody' />Mother or Father has Sole Legal Custody</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCustody_Other' name='cbCustody_Other' className='add-only' value='Other (describe)' />Other (describe):
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txCustodyOther' name='txCustodyOther' className='add-only'></textarea>
                </p>


                <p className='w-750'><center><h3>Family Environment/Relationships/Family Supports</h3></center></p>


                <table>
                    <tr>
                        <td className='w-200'><b>Parent-Child (Client) Relationship(s):</b></td>
                        <td className='w-200'> <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='Not Applicable' /> Not Applicable</td>
                        <td className='w-350'><b>P = Primary Household <br />S = Secondary Household <br />B = Both</b></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment on Parent-Child Relationships</span>
                    <span className='small'>(could include: parent-child conflict; parent supervision and monitoring of child; cooperation between parent(s) regarding child-rearing; parent positive activities with child; parent satisfaction with relationship; child satisfaction with relationship, consumer family supports including natural and informal supports)</span>
                    <textarea id='txtParentChildRelationships' name='txtParentChildRelationships' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-200'><b>Sibling-Child (Client) Relationship(s )</b></td>
                        <td className='w-200'> <input type='checkbox' id='cbNoSiblings' name='cbNoSiblings' className='add-only' value='No Siblings' /> No Siblings</td>
                        <td className='w-350'><b>P = Primary Household <br />S = Secondary Household <br />B = Both</b></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment on Sibling-Child Relationships</span>
                    <span className='small'>(could include: child-sibling(s) conflict; sibling(s) positive activities with child; sibling(s) satisfaction with relationship; child satisfaction with relationship)</span>
                    <textarea id='txtSiblingChildRelationships' name='txtSiblingChildRelationships' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-200'><b>Parent Marital or Couples Relationship(s) </b></td>
                        <td className='w-200'> <input type='checkbox' id='cbApplicable' name='cbApplicable' className='add-only' value='Not Applicable in this Case' /> Not Applicable in this Case</td>
                        <td className='w-350'><b>P = Primary Household <br />S = Secondary Household <br />B = Both</b></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment on parent Marital or Couples Relationship(s) </span>
                    <span className='small'>(could include: marital or couples conflict; marital or couples satisfaction)</span>
                    <textarea id='txtCouplesRelationships' name='txtCouplesRelationships' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Social Information</h3></center></p>
                <p className='w-750'>
                    <span className='eleHeader'>Pertinent Family History </span>
                    <span className='small'>(to include family DD, MH and AoD history)</span>
                    <textarea id='txtPertinent' name='txtPertinent' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Strengths/Weaknesses/Preferences/Interests/Skills/Needs</span>
                    <textarea id='txtStrengths' name='txtStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Limitations of Activities of Daily Living</span>
                    <textarea id='txtLimitations' name='txtLimitations' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Friendship/Social Peer Support/Relationships</span>
                    <textarea id='txtFriendship' name='txtFriendship' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Meaningful Activities </span>
                    <span className='small'>(community involvements, volunteer activities, leisure/recreation, other interests)</span>
                    <textarea id='txtMeaningful' name='txtMeaningful' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Community Supports/Self Help Groups </span>
                    <span className='small'> (NA, NAMI,etc.)</span>
                    <textarea id='txtCommunitySupports' name='txtCommunitySupports' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Religion/Spirituality Strengths</span>
                    <textarea id='txtSpirituality' name='txtSpirituality' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Cultural/Ethnic Strengths/Issues</span>
                    <textarea id='txtEthnicStrengths' name='txtEthnicStrengths' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Pertinent Developmental Issues</h3></center></p>
                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbPregnancy' name='cbPregnancy' className='add-only' value='MothersPregnancyHistory' /> {`Mother’s Pregnancy History`}</span>
                    <span className='small'>(include prenatal exposure to alcohol, tobacco or other drugs)</span>
                    <textarea id='txtPregnancyHistory' name='txtPregnancyHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbInfancy' name='cbInfancy' className='add-only' value='InfancyAge01' /> Infancy (age 0-1)</span>
                    <textarea id='txtInfancy' name='txtInfancy' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'><input type='checkbox' id='cbPreschool' name='cbPreschool' className='add-only' value='PreschoolAge2' /> Preschool (age 2-4)</span>
                    <textarea id='txtPreschool' name='txtPreschool' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'><input type='checkbox' id='cbChildhood' name='cbChildhood' className='add-only' value='ChildhoodAge5' /> Childhood (age 5-12)</span>
                    <textarea id='txtChildhood' name='txtChildhood' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'><input type='checkbox' id='cbAdolescent' name='cbAdolescent' className='add-only' value='AdolescentAge17' /> Adolescent (age 13-17)</span>
                    <textarea id='txtAdolescent' name='txtAdolescent' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Sexual History to Include Pertinent Sexual Issues/Concerns/Gender Orientation /Gender/Expression </span>
                    <textarea id='txtSexualHistory' name='txtSexualHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>School Functioning</h3></center>
                    <h4>Educational Classification </h4></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of School:</span>
                            <input type='text' id='txtSchool' name='txtSchool' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Grade:</span>
                            <input type='text' id='txtCurrentGrade' name='txtCurrentGrade' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Regular Education Classroom, No Special Services</span>
                            <input type='radio' id='rbEducation_Yes' name='rbEducation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEducation_No' name='rbEducation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span><b>If no, check all that apply.</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='checkbox' id='cbMultipleDisabilities' name='cbMultipleDisabilities' className='add-only' value='01 Multiple disabilities (not deaf-blind)' /> 01 Multiple disabilities (not deaf-blind)</td>
                        <td className='w-250'> <input type='checkbox' id='cbOrthopedicImpairment' name='cbOrthopedicImpairment' className='add-only' value='06 Orthopedic Impairment' /> 06 Orthopedic Impairment</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbAutism' name='cbAutism' className='add-only' value='11 Autism' /> 11 Autism</td>
                        <td className='w-250'> <input type='checkbox' id='cbDeafBlindness' name='cbDeafBlindness' className='add-only' value='02 Deaf-Blindness' /> 02 Deaf-Blindness</td>
                        <td className='w-250'> <input type='checkbox' id='cbEmotionalDisturbance' name='cbEmotionalDisturbance' className='add-only' value='07 Emotional Disturbance (SBH)' /> 07 Emotional Disturbance (SBH)</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbTraumatic' name='cbTraumatic' className='add-only' value='12 Traumatic Brain Injury' /> 12 Traumatic Brain Injury</td>
                        <td className='w-250'> <input type='checkbox' id='cbDeafness' name='cbDeafness' className='add-only' value='03 Deafness (hearing impairment)' /> 03 Deafness (hearing impairment)</td>
                        <td className='w-250'> <input type='checkbox' id='cbRetardation' name='cbRetardation' className='add-only' value='08 Mental Retardation (DH)' /> 08 Mental Retardation (DH)</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbHealth' name='cbHealth' className='add-only' value='13 Other Health Impaired (major)' /> 13 Other Health Impaired (major)</td>
                        <td className='w-250'> <input type='checkbox' id='cbImpairment' name='cbImpairment' className='add-only' value='04 Visual Impairment' /> 04 Visual Impairment</td>
                        <td className='w-250'> <input type='checkbox' id='cbDisability' name='cbDisability' className='add-only' value='09 Specific Learning Disability' /> 09 Specific Learning Disability</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbImpaired' name='cbImpaired' className='add-only' value='14 Other Health Impaired (minor)' /> 14 Other Health Impaired (minor)</td>
                        <td className='w-500'> <input type='checkbox' id='cbLanguageImpairment' name='cbLanguageImpairment' className='add-only' value='05 Speech or Language Impairment' /> 05 Speech or Language Impairment</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbPreschoolers' name='cbPreschoolers' className='add-only' value='10 Preschoolers with a Disability' /> 10 Preschoolers with a Disability</td>
                        <td className='w-250'> <input type='checkbox' id='cbCurrent' name='cbCurrent' className='add-only' value='15 Current 504 Plan' /> 15 Current 504 Plan</td>
                        <td className='w-250'> <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other: EMD-SC class' /> Other: EMD-SC class</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments on Educational Classification/Placement </span>
                    <span className='small'>(please indicate if client is home schooled, in gifted program, etc.)</span>
                    <textarea id='txtCheckAll' name='txtCheckAll' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbLiteracyLevel' name='cbLiteracyLevel' className='add-only' value='Literacy Level' /> Literacy Level</span>
                    <textarea id='txtLiteracyLevel' name='txtLiteracyLevel' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbAttendance' name='cbAttendance' className='add-only' value='Attendance' /> Attendance</span>
                    <textarea id='txtAttendance' name='txtAttendance' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbRetentions' name='cbRetentions' className='add-only' value='Previous Grade Retentions' /> Previous Grade Retentions</span>
                    <textarea id='txtRetentions' name='txtRetentions' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'><input type='checkbox' id='cbSuspensions' name='cbSuspensions' className='add-only' value='Suspensions/Expulsions' /> Suspensions/Expulsions</span>
                    <textarea id='txtSuspensions' name='txtSuspensions' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    
                    <span className='eleHeader'><input type='checkbox' id='cbAcademic' name='cbAcademic' className='add-only' value='Other Academic/School Concerns' /> Other Academic/School Concerns</span>
                    <span className='small'>(including performance/behavioral problems due to AoD use) </span>
                    <textarea id='txtAcademic' name='txtAcademic' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Barriers to Learning</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbBarriers_1' name='cbBarriers_1' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'> <input type='checkbox' id='cbBarriers_2' name='cbBarriers_2' className='add-only' value='InabilityReadAndWrite' /> Inability to Read and Write</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbBarriers_3' name='cbBarriers_3' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtBarriers_3' name='txtBarriers_3' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Peer Relationships/Social Functioning </span>
                    <textarea id='txtPeerRelationships' name='txtPeerRelationships' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Special Communication Needs </span>
                <table>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbSpecialCommunication_1' name='cbSpecialCommunication_1' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'> <input type='checkbox' id='cbSpecialCommunication_2' name='cbSpecialCommunication_2' className='add-only' value='TddTtyDevice' /> TDD/TTY Device</td>
                        <td className='w-250'> <input type='checkbox' id='cbSpecialCommunication_3' name='cbSpecialCommunication_3' className='add-only' value='SignLanguageInterpreter' /> Sign Language Interpreter</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbSpecialCommunication_4' name='cbSpecialCommunication_4' className='add-only' value='AssistiveListeningDevice' /> Assistive Listening Device(s)</td>
                        <td className='w-500'> <input type='checkbox' id='cbSpecialCommunication_5' name='cbSpecialCommunication_5' className='add-only' value='LanguageInterpreterServicesNeededOtherSpokenLanguage' /> Language Interpreter Services Needed/Other Spoken Language:</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <textarea id='txtOtherSpokenLanguage' name='txtOtherSpokenLanguage' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Legal History</h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'><b>Does client have Psychiatric Advance Directives?</b></span>
                            <span className='small'>(If yes, attach Advance Directives to Assessment)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDirectives_Yes' name='rbDirectives' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDirectives_No' name='rbDirectives' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Current Legal Status  </span></p>
                <table>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_1' name='cbLegalStatus_1' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_2' name='cbLegalStatus_2' className='add-only' value='OnProbation' /> On Probation</td>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_3' name='cbLegalStatus_3' className='add-only' value='Detention' /> Detention</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_4' name='cbLegalStatus_4' className='add-only' value='OnParole' /> On Parole</td>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_5' name='cbLegalStatus_5' className='add-only' value='AwaitingCharge' /> Awaiting Charge</td>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_6' name='cbLegalStatus_6' className='add-only' value='AodRelatedLegalProblems' /> AoD Related Legal Problems</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbLegalStatus_7' name='cbLegalStatus_7' className='add-only' value='CourtOrderedTreatment' /> Court Ordered to Treatment</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbLegalStatus_8' name='cbLegalStatus_8' className='add-only' value='Others' /> Others: &nbsp;
                            <input type='text' id='txtLegalStatus_8' name='txtLegalStatus_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><b>History of Legal Charges </b> &nbsp;
                            <input type='radio' id='rbLegalCharges_No' name='rbLegalCharges' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbLegalCharges_Yes' name='rbLegalCharges' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td><b>If yes, check and describe:</b></td>
                        <td className='w-250'> <input type='checkbox' id='cbOffense_1' name='cbOffense_1' className='add-only' value='Status Offense (eg Unruly)' /> Status Offense (eg Unruly)</td>
                        <td className='w-250'> <input type='checkbox' id='cbOffense_2' name='cbOffense_2' className='add-only' value='Delinquency' /> Delinquency </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Name of Probation/Parole Officer (if applicable)</span>
                    <textarea id='txtProbation' name='txtProbation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Adjudications</b> &nbsp;
                            <input type='radio' id='rbAdjudications_No' name='rbAdjudications' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAdjudications_Yes' name='rbAdjudications' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe:</span>
                    <textarea id='txtAdjudications_Describe' name='txtAdjudications_Describe' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Detentions or Incarcerations</b> &nbsp;
                            <input type='radio' id='rbIncarcerations_No' name='rbIncarcerations' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbIncarcerations_Yes' name='rbIncarcerations' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe:</span>
                    <textarea id='txtIncarcerations_Describe' name='txtIncarcerations_Describe' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Civil Proceedings</b> &nbsp;
                            <input type='radio' id='rbProceedings_No' name='rbProceedings' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbProceedings_Yes' name='rbProceedings' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe:</span>
                    <textarea id='txtProceedings_Describe' name='txtProceedings_Describe' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Domestic Relations Court Involvement</b> &nbsp;
                            <input type='radio' id='rbDomestic_No' name='rbDomestic' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbDomestic_Yes' name='rbDomestic' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe:</span>
                    <textarea id='txtDomestic_Describe' name='txtDomestic_Describe' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Juvenile Court Involvement </span>
                <span className='small'>(related to child abuse, neglect, or dependency) </span>
                <table>
                    <tr>
                        <td className='w-100'>
                            <b>Current:</b>
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrent_No' name='rbCurrent' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbCurrent_Yes' name='rbCurrent' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-550'>
                            Comment: &nbsp;
                            <input type='text' id='txtCurrent_Comment' name='txtCurrent_Comment' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Past:</b>
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPast_No' name='rbPast' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbPast_Yes' name='rbPast' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-550'>
                            Comment: &nbsp;
                            <input type='text' id='txtPast_Comment' name='txtPast_Comment' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Case Worker Name (if applicable)</span>
                            <input type='text' id='txtWorker' name='txtWorker' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span><b>{`Children’s Protective Services Involvement with Family`}</b></span> &nbsp;
                            <input type='radio' id='rbProtective_No' name='rbProtective' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbProtective_Yes' name='rbProtective' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, describe:</span>
                    <textarea id='txtProtective_Describe' name='txtProtective_Describe' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span><b>Name of CPS Caseworker(s) Assigned to Family  </b>(if applicable)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCaseworker' name='cbCaseworker' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span><b>Name of Guardian ad Litem (GAL) </b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGuardian_1' name='cbGuardian_1' className='add-only' value='NoneReported' /> None Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGuardian_2' name='cbGuardian_2' className='add-only' value='NotPertinentSkipThisSection' /> Not Pertinent - Skip this Section
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Employment</b> &nbsp;
                            <input type='text' id='txtEmployment' name='txtEmployment' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Currently Employed?</b> &nbsp;
                            <input type='radio' id='rbEmployed_Yes' name='rbEmployed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEmployed_No' name='rbEmployed' className='add-only' value='No' /> No
                            If yes, name of employer: &nbsp;
                            <input type='text' id='txtEmp' name='txtEmp' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Job Title</b> &nbsp;
                            <input type='text' id='txtJobTitle' name='txtJobTitle' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Employment Interests/Skills/Concerns</span>
                    <textarea id='txtEmploymentInterests' name='txtEmploymentInterests' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Mental Health Treatment History</h3></center></p>
                <p className='w-750'><span className='eleHeader'>Outpatient Mental Health Treatment</span>
                    <input type='checkbox' id='cbNoneReported_1' name='cbNoneReported_1' className='add-only' value='NoneReported' /> None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span><b>Agency</b></span></td>
                        <td className='w-150'><span><b>Indicate  if Current</b></span></td>
                        <td className='w-150'><span><b>Past (Date)</b></span></td>
                        <td className='w-200'><span><b>Clinician Name</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgency_1' name='txtAgency_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtIndicate_1' name='txtIndicate_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtPastDate_1' name='txtPastDate_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtClinicianName_1' name='txtClinicianName_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgency_2' name='txtAgency_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtIndicate_2' name='txtIndicate_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtPastDate_2' name='txtPastDate_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtClinicianName_2' name='txtClinicianName_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgency_3' name='txtAgency_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtIndicate_3' name='txtIndicate_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtPastDate_3' name='txtPastDate_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtClinicianName_3' name='txtClinicianName_3' className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>Psychiatric Hospitalizations/Residential Treatment Facilities &nbsp;
                    <input type='checkbox' id='cbNoneReported_2' name='cbNoneReported_2' className='add-only' value='NoneReported' /> None Reported
                </span>
                <table>
                    <tr>
                        <td className='w-300'><span><b>Facility</b></span></td>
                        <td className='w-150'><span><b>Date of Service</b></span></td>
                        <td className='w-300'><span><b>Reason (suicidal, depressed, etc.)</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtFacility_1' name='txtFacility_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtService_1' name='txtService_1' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtFacility_2' name='txtFacility_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtService_2' name='txtService_2' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Has there been a Child and Family Team Mtg?</b> &nbsp;
                            <input type='radio' id='rbTeam_No' name='rbTeam' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbTeam_Yes' name='rbTeam' className='add-only' value='Yes' /> Yes (if yes indicate date and LME name)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>LME Name</b></td>
                        <td className='w-150'><b>Date of Meeting</b></td>
                        <td className='w-300'><b>LME Child and Family Team Representative</b></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtLMEName' name='txtLMEName' className='add-only w-290 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtMeeting' name='txtMeeting' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtRepresentative' name='txtRepresentative' className='add-only w-290 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>Previous or Current Diagnoses </span>
                <span className='small'>(if known) </span>
                <table>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbKnownClient' name='cbKnownClient' className='add-only' value='Not Known by Client' /> Not Known by Client
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtDiagnoses' name='txtDiagnoses' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Response to Mental Health Treatment </span>
                <span className='small'>(most or least helpful barriers) </span>
                <table>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbNoComment' name='cbNoComment' className='add-only' value='No Comment' /> No Comment
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtNoComment' name='txtNoComment' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Pertinent Health Issues/Medical History</h3></center></p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'><b>Illness</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>Symptoms</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>Treatment</b></span></td>
                        <td className='w-200'><span className='eleHeader'><b>Treatment Response</b></span></td>
                        <td className='w-200'><span className='eleHeader'><b>Barriers to Recovery</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtIllness' name='txtIllness' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSymptoms' name='txtSymptoms' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatment' name='txtTreatment' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtTreatmentResponse' name='txtTreatmentResponse' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtBarriers' name='txtBarriers' className='add-only' />
                        </td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-150'><span><b>Hearing</b></span></td>
                        <td className='w-150'><input type='checkbox' id='cbHearing_1' name='cbHearing_1' className='add-only' value='WNL' /> WNL</td>
                        <td className='w-150'><input type='checkbox' id='cbHearing_2' name='cbHearing_2' className='add-only' value='Impaired' /> Impaired</td>
                        <td className='w-150'><input type='checkbox' id='cbHearing_3' name='cbHearing_3' className='add-only' value='Needs follow-up' /> Needs follow-up </td>
                        <td className='w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><span><b>Vision</b></span></td>
                        <td className='w-150'><input type='checkbox' id='cbVision_1' name='cbVision_1' className='add-only' value='WNL' /> WNL</td>
                        <td className='w-150'><input type='checkbox' id='cbVision_2' name='cbVision_2' className='add-only' value='Impaired' /> Impaired</td>
                        <td className='w-150'><input type='checkbox' id='cbVision_3' name='cbVision_3' className='add-only' value='Needs follow-up' /> Needs follow-up </td>
                        <td className='w-150'><input type='checkbox' id='cbVision_4' name='cbVision_4' className='add-only' value='Wears glasses' />Wears glasses </td>
                    </tr>
                    <tr>
                        <td className='w-150'><span><b>Immunizations</b></span></td>
                        <td className='w-150'><input type='checkbox' id='cbImmunizations_1' name='cbImmunizations_1' className='add-only' value='Up to date' /> Up to date</td>
                        <td className='w-150'><input type='checkbox' id='cbImmunizations_2' name='cbImmunizations_2' className='add-only' value='Needs follow-up' /> Needs follow-up </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Current Pregnancy/Prenatal Care</h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span><b>Currently Pregnant?</b></span> &nbsp;
                            <input type='radio' id='rbPregnant_Yes' name='rbPregnant' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPregnant_No' name='rbPregnant' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><b>Receiving Prenatal Care? </b></span> &nbsp;
                            <input type='radio' id='rbPrenatal_Yes' name='rbPrenatal' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPrenatal_No' name='rbPrenatal' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>Current Medication</span>
                    <span className='small'>(prescription/OTC/herbal)</span>
                    <input type='checkbox' id='cbNoneReported_3' name='cbNoneReported_3' className='add-only' value='NoneReported' /> None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'><b>Medication</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>Rationale</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>Treatment Efficacy</b></span></td>
                        <td className='w-150'><span className='eleHeader'><b>Dosage/Route/ Frequency</b></span></td>
                        <td className='w-200'><span className='eleHeader'><b>Compliance</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-150'></td>
                        <td className='w-100'></td>
                        <td className='w-100'></td>
                        <td className='w-150'></td>
                        <td className='w-50'><b>Yes</b></td>
                        <td className='w-50'><b>No</b></td>
                        <td className='w-50'><b>Partial</b></td>
                        <td className='w-50'><b>Unk.</b></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtRationale_1' name='txtRationale_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatmentEfficacy_1' name='txtTreatmentEfficacy_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Yes_1' name='cbPM_Yes_1' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_No_1' name='cbPM_No_1' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Partial_1' name='cbPM_Partial_1' className='add-only' value='Partial' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Unk_1' name='cbPM_Unk_1' className='add-only' value='Unk' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtRationale_2' name='txtRationale_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatmentEfficacy_2' name='txtTreatmentEfficacy_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Yes_2' name='cbPM_Yes_2' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_No_2' name='cbPM_No_2' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Partial_2' name='cbPM_Partial_2' className='add-only' value='Partial' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Unk_2' name='cbPM_Unk_2' className='add-only' value='Unk' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtRationale_3' name='txtRationale_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatmentEfficacy_3' name='txtTreatmentEfficacy_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Yes_3' name='cbPM_Yes_3' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_No_3' name='cbPM_No_3' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Partial_3' name='cbPM_Partial_3' className='add-only' value='Partial' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Unk_3' name='cbPM_Unk_3' className='add-only' value='Unk' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtRationale_4' name='txtRationale_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatmentEfficacy_4' name='txtTreatmentEfficacy_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Yes_4' name='cbPM_Yes_4' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_No_4' name='cbPM_No_4' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Partial_4' name='cbPM_Partial_4' className='add-only' value='Partial' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Unk_4' name='cbPM_Unk_4' className='add-only' value='Unk' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtRationale_5' name='txtRationale_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtTreatmentEfficacy_5' name='txtTreatmentEfficacy_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Yes_5' name='cbPM_Yes_5' className='add-only' value='Yes' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_No_5' name='cbPM_No_5' className='add-only' value='No' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Partial_5' name='cbPM_Partial_5' className='add-only' value='Partial' />
                        </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbPM_Unk_5' name='cbPM_Unk_5' className='add-only' value='Unk' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Care Physician (name, phone no., and address)</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Physical Exam </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrimaryCare' name='txtPrimaryCare' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDatePhysical' name='txtDatePhysical' className='add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychiatrist</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Visit</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPsychiatrist' name='txtPsychiatrist' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtLastVisit' name='txtLastVisit' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Past Psychotropic Medications</span>
                    <input type='checkbox' id='cbNoneReported_4' name='cbNoneReported_4' className='add-only' value='NoneReported' /> None Reported

                </p>

                <table>
                    <tr>
                        <td className='w-250'><span><b>Psychotropic Medications</b></span></td>
                        <td className='w-500'><span><b>Efficacy of Previously Used Psychotropic Medication</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychotropic_1' name='txtPsychotropic_1' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtEfficacy_1' name='txtEfficacy_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychotropic_2' name='txtPsychotropic_2' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtEfficacy_2' name='txtEfficacy_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychotropic_3' name='txtPsychotropic_3' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtEfficacy_3' name='txtEfficacy_3' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Alcohol/Drug History</h3></center></p>
                <table>
                    <tr>
                        <td className='w-375'><b>Illegal drug use/abuse past 12 months?</b>

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbIllegal_No' name='rbIllegal' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbIllegal_Yes' name='rbIllegal' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Non-prescription drug abuse past 12 months?</b>

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbNonPrescription_No' name='rbNonPrescription' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbNonPrescription_Yes' name='rbNonPrescription' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Prescription drug abuse past 12 months?</b>

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbPrescription_No' name='rbPrescription' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbPrescription_Yes' name='rbPrescription' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Alcohol use/abuse past 12 months?</b>

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol_No' name='rbAlcohol' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbAlcohol_Yes' name='rbAlcohol' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Toxicology screen completed?</b>

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbToxicology_No' name='rbToxicology' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbToxicology_Yes' name='rbToxicology' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, results:</span>
                    <textarea id='txtResults' name='txtResults' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>Presenting with detox issues? </b> &nbsp;
                            <input type='radio' id='rbPresenting_No' name='rbPresenting' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbPresenting_Yes' name='rbPresenting' className='add-only' value='Yes' /> Yes
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, symptoms:</span>
                    <textarea id='txtSymptoms_1' name='txtSymptoms_1' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Check All That apply </span>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDrugUser' name='cbDrugUser' className='add-only' value='IV Drug User' /> IV Drug User</td>
                        <td className='w-250'><input type='checkbox' id='cbPregnant' name='cbPregnant' className='add-only' value='Pregnant' /> Pregnant</td>
                        <td className='w-250'><input type='checkbox' id='cbAddictive' name='cbAddictive' className='add-only' value='Other Addictive Behaviors' /> Other Addictive Behaviors</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtAddictive' name='txtAddictive' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><b>Drug/Substance/Alcohol/ Tobacco/OTC</b></td>
                        <td className='w-50'><b>Age of First Use</b></td>
                        <td className='w-150'><b>Date of Last Use</b></td>
                        <td className='w-75'><b>Frequency of Use</b></td>
                        <td className='w-75'><b>Amount</b></td>
                        <td className='w-150'><b>Method</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSubstance_1' name='txtSubstance_1' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtFirstUse_1' name='txtFirstUse_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastUse_1' name='txtLastUse_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAmount_1' name='txtAmount_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtMethod_1' name='txtMethod_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSubstance_2' name='txtSubstance_2' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtFirstUse_2' name='txtFirstUse_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastUse_2' name='txtLastUse_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAmount_2' name='txtAmount_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtMethod_2' name='txtMethod_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSubstance_3' name='txtSubstance_3' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtFirstUse_3' name='txtFirstUse_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastUse_3' name='txtLastUse_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAmount_3' name='txtAmount_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtMethod_3' name='txtMethod_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSubstance_4' name='txtSubstance_4' className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type='text' id='txtFirstUse_4' name='txtFirstUse_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastUse_4' name='txtLastUse_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAmount_4' name='txtAmount_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtMethod_4' name='txtMethod_4' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Means of Obtaining Substance: </span>
                    <textarea id='txtObtaining' name='txtObtaining' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Motivation for use: </span>
                    <textarea id='txtMotivation' name='txtMotivation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Interest in reducing use and attaining abstinence: </span>
                    <textarea id='txtInterest' name='txtInterest' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Problems usage may have caused:</span>
                    <textarea id='txtProblems' name='txtProblems' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Check all that apply:  </span>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbDWI' name='cbDWI' className='add-only' value='DWI' /> DWI</td>
                        <td className='w-187'><input type='checkbox' id='cbBlackouts' name='cbBlackouts' className='add-only' value='Blackouts' /> Blackouts</td>
                        <td className='w-187'><input type='checkbox' id='cbAbsenteeism' name='cbAbsenteeism' className='add-only' value='Absenteeism' /> Absenteeism</td>
                        <td className='w-187'><input type='checkbox' id='cbSeizures' name='cbSeizures' className='add-only' value='Seizures' /> Seizures</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbJobLoss' name='cbJobLoss' className='add-only' value='JobLoss' /> Job loss </td>
                        <td className='w-187'><input type='checkbox' id='cbDrug' name='cbDrug' className='add-only' value='IvDrugUse' /> IV Drug Use</td>
                        <td className='w-187'><input type='checkbox' id='cbPreg' name='cbPreg' className='add-only' value='Pregnant' /> Pregnant</td>
                    </tr>
                </table>

                <span className='eleHeader'>Stages of Change: </span>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPrecontemplation' name='cbPrecontemplation' className='add-only' value='Precontemplation' /> Precontemplation</td>
                        <td className='w-187'><input type='checkbox' id='cbContemplation' name='cbContemplation' className='add-only' value='Contemplation' /> Contemplation</td>
                        <td className='w-187'><input type='checkbox' id='cbPreparation' name='cbPreparation' className='add-only' value='Preparation' /> Preparation</td>
                        <td className='w-187'><input type='checkbox' id='cbAction' name='cbAction' className='add-only' value='Action' /> Action</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMaintenance' name='cbMaintenance' className='add-only' value='Maintenance' /> Maintenance</td>
                        <td className='w-187'><input type='checkbox' id='cbRelapse' name='cbRelapse' className='add-only' value='Relapse' /> Relapse</td>
                    </tr>
                </table>

                <p className='w-750'><h4>ASAM CRITERIA </h4>
                    <span className='eleHeader'>Please select the appropriate level:</span>
                    <input type='checkbox' id='cbNA' name='cbNA' className='add-only' value='N/A' /> N/A
                </p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntervention' name='cbIntervention' className='add-only' value='Level05EarlyIntervention' /> {`Level 0.5 – Early Intervention`}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOutpatient' name='cbOutpatient' className='add-only' value='Level1OutpatientServices' /> {`Level 1 – Outpatient Services  `}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntensive' name='cbIntensive' className='add-only' value='Level21IntensiveOutpatientServicesSaiop' /> {`Level 2.1 – Intensive Outpatient Services (SAIOP) `}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHospitalization' name='cbHospitalization' className='add-only' value='Level25PartialHospitalizationServicesSacot' /> {`Level 2.5 – Partial Hospitalization Services (SACOT) `}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbClinically' name='cbClinically' className='add-only' value='Level31ClinicallyManagedLowIntensityResidentialServices' /> {`Level 3.1 – Clinically Managed, Low-Intensity Residential Services  `}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbResidential' name='cbResidential' className='add-only' value='Level33ClinicallyManagedPopulationSpecificHighIntensityResidentialServices' /> {`  Level 3.3 – Clinically Managed Population-Specific, High-Intensity Residential services `} </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntensityResidential' name='cbIntensityResidential' className='add-only' value='Level35ClinicallyManageHighIntensityResidentialServicesAdultCriteria' /> {`Level 3.5 – Clinically Manage High-Intensity Residential Services (Adult Criteria)`} </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInpatient' name='cbInpatient' className='add-only' value='Level37MedicallyMonitoredIntensiveInpatientServicesAdultCriteria' /> {`Level 3.7 – Medically Monitored Intensive Inpatient Services (Adult Criteria)`}</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMonitored' name='cbMonitored' className='add-only' value='Level39MedicallyMonitoredManagedIntensiveInpatientServices' /> {`Level 3.9 – Medically Monitored/Managed Intensive Inpatient Services `} </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedically' name='cbMedically' className='add-only' value='Level40MedicallyManagedIntensiveInpatientServices' /> {`Level 4.0 – Medically Managed Intensive Inpatient Services `} </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b>
                        ** Lack of availability of appropriate, criteria-selected care and/or poor outcomes at a given level of care warrant a reassessment of the treatment plan with a view to modify the treatment approach.
                    </b>
                </p>

                <p className='w-750'><span className='eleHeader'>American Society for Addition Medicine (ASAM) Criteria (use High/Medium/Low ONLY):</span></p>
                <table>
                    <tr>
                        <td className='w-100'><b>Dimension 1.</b></td>
                        <td className='w-275'>Detoxification/Withdrawal potential:</td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_1' name='txtDimension_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Dimension 2.</b></td>
                        <td className='w-275'>Medical conditions & complication:</td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_2' name='txtDimension_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Dimension 3.</b></td>
                        <td className='w-275'>Emotional/behavioral conditions & complications: </td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_3' name='txtDimension_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Dimension 4.</b></td>
                        <td className='w-275'>Treatment acceptance/resistance: </td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_4' name='txtDimension_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Dimension 5.</b></td>
                        <td className='w-275'>Relapse/continues use potential:  </td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_5' name='txtDimension_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><b>Dimension 6.</b></td>
                        <td className='w-275'>Recovery environment:</td>
                        <td className='w-375'>
                            <input type='text' id='txtDimension_6' name='txtDimension_6' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>Alcohol/Drug Treatment History</h4></center>
                    <span className='eleHeader'>AoD Treatment</span>
                    <input type='checkbox' id='cbNoneReported_5' name='cbNoneReported_5' className='add-only' value='NoneReported' /> None Reported
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><b>Current:</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbCurrent_1' name='cbCurrent_1' className='add-only' value='Op' />  OP</td>
                        <td className='w-125'><input type='checkbox' id='cbCurrent_2' name='cbCurrent_2' className='add-only' value='Iop' />  IOP</td>
                        <td className='w-125'><input type='checkbox' id='cbCurrent_3' name='cbCurrent_3' className='add-only' value='Residential' />  Residential</td>
                        <td className='w-375'><input type='checkbox' id='cbCurrent_4' name='cbCurrent_4' className='add-only' value='Other' />  Other: &nbsp;
                            <input type='text' id='txtOther1' name='txtOther1' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span><b>Past:</b></span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbPast_1' name='cbPast_1' className='add-only' value='Op' />  OP</td>
                        <td className='w-125'><input type='checkbox' id='cbPast_2' name='cbPast_2' className='add-only' value='Iop' />  IOP</td>
                        <td className='w-125'><input type='checkbox' id='cbPast_3' name='cbPast_3' className='add-only' value='Residential' />  Residential</td>
                        <td className='w-125'><input type='checkbox' id='cbPast_4' name='cbPast_4' className='add-only' value='Hospital' /> Hospital</td>
                        <td className='w-125'><input type='checkbox' id='cbPast_5' name='cbPast_5' className='add-only' value='Detox' />  Detox</td>
                        <td className='w-125'><input type='checkbox' id='cbPast_6' name='cbPast_6' className='add-only' value='Other' />  Other:</td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>If current or past complete the following:</span></p>


                <table>
                    <tr>
                        <td className='w-300'><span><b>Name of Provider Agency</b></span></td>
                        <td className='w-300'><span><b>Type of Service</b></span></td>
                        <td className='w-150'><span><b>Date of Service</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtProvider' name='txtProvider' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtService' name='txtService' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other Comments Regarding Substance Abuse/Use and Other Addictive Behaviors</span>
                    <span className='small'>(include AoD use/abuse by other family members/significant others, AoD related legal problems) </span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>
                <p className='w-750'><center><h3>Abuse History</h3><span className='small'>(describe in comments section each element checked)</span></center></p>

                <table>
                    <tr>
                        <td className='w-500'><input type='checkbox' id='cbAH_1' name='cbAH_1' className='add-only' value='No Self reported History of Abuse/Violence' /> No Self reported History of Abuse/Violence</td>
                        <td className='w-250'><input type='checkbox' id='cbAH_2' name='cbAH_2' className='add-only' value='Physical Abuse' /> Physical Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAH_3' name='cbAH_3' className='add-only' value='Domestic Violence/Abuse' /> Domestic Violence/Abuse</td>
                        <td className='w-250'><input type='checkbox' id='cbAH_4' name='cbAH_4' className='add-only' value='Community Violence' /> Community Violence</td>
                        <td className='w-250'><input type='checkbox' id='cbAH_5' name='cbAH_5' className='add-only' value='Physical Neglect' /> Physical Neglect</td>

                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAH_6' name='cbAH_6' className='add-only' value='Emotional Abuse' /> Emotional Abuse</td>
                        <td className='w-250'><input type='checkbox' id='cbAH_7' name='cbAH_7' className='add-only' value='Sexual Abuse/Molestation' /> Sexual Abuse/Molestation</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAH_8' name='cbAH_8' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAH_8' name='txtAH_8' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments</span>
                    <span className='small'>(identify if client was/is a victim of abuse or a perpetrator or both) </span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Problem Checklist Including Functional Domains</h3></center></p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPreferences' name='cbPreferences' className='add-only' value='Check applicable age appropriate needs/preferences for the identified child/adolescent client and comment' />  (Check applicable age appropriate needs/preferences for the identified child/adolescent client and comment.)</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-75'><span className='eleHeader'><b>Check</b></span></td>
                        <td className='w-275'><span className='eleHeader'><b>Check All Current Problem Areas</b></span></td>
                        <td className='w-400'><span className='eleHeader'><b>As Evidenced By </b></span></td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbNutritional' name='cbNutritional' className='add-only' value='Nutritional/Eating Pattern Changes/Disorders' /></center></td>
                        <td className='w-275'><span>Nutritional/Eating Pattern Changes/Disorders</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_1' name='txtEvidencedBy_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbPainManagement' name='cbPainManagement' className='add-only' value='Pain Management' /></center></td>
                        <td className='w-275'><span>Pain Management</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_2' name='txtEvidencedBy_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed Mood/Sad' /></center></td>
                        <td className='w-275'><span>Depressed Mood/Sad</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_3' name='txtEvidencedBy_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbBereavement' name='cbBereavement' className='add-only' value='Bereavement Issues' /></center></td>
                        <td className='w-275'><span>Bereavement Issues</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_4' name='txtEvidencedBy_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbAnxiety' name='cbAnxiety' className='add-only' value='Anxiety' /></center></td>
                        <td className='w-275'><span>Anxiety</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_5' name='txtEvidencedBy_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbTraumaticStress' name='cbTraumaticStress' className='add-only' value='Traumatic Stress' /></center></td>
                        <td className='w-275'><span>Traumatic Stress</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_6' name='txtEvidencedBy_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbAggression' name='cbAggression' className='add-only' value='Anger/Aggression' /></center></td>
                        <td className='w-275'><span>Anger/Aggression</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_7' name='txtEvidencedBy_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbOppositional' name='cbOppositional' className='add-only' value='Oppositional Behaviors' /></center></td>
                        <td className='w-275'><span>Oppositional Behaviors</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_8' name='txtEvidencedBy_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbInattention' name='cbInattention' className='add-only' value='Inattention' /></center></td>
                        <td className='w-275'><span>Inattention</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_9' name='txtEvidencedBy_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbImpulsivity' name='cbImpulsivity' className='add-only' value='Impulsivity' /></center></td>
                        <td className='w-275'><span>Impulsivity</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_10' name='txtEvidencedBy_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbDisturbed' name='cbDisturbed' className='add-only' value='Disturbed Reality Contact (psychosis)' /></center></td>
                        <td className='w-275'><span>Disturbed Reality Contact (psychosis)</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_11' name='txtEvidencedBy_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbHyperactivity' name='cbHyperactivity' className='add-only' value='Mood Swings/Hyperactivity' /></center></td>
                        <td className='w-275'><span>Mood Swings/Hyperactivity</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_12' name='txtEvidencedBy_12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbAddictiveBehaviors' name='cbAddictiveBehaviors' className='add-only' value='Other Addictive Behaviors' /></center></td>
                        <td className='w-275'><span>Other Addictive Behaviors</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_13' name='txtEvidencedBy_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbSleepProblems' name='cbSleepProblems' className='add-only' value='Sleep Problems' /></center></td>
                        <td className='w-275'><span>Sleep Problems</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_14' name='txtEvidencedBy_14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbEnuresis' name='cbEnuresis' className='add-only' value='Enuresis/Encopresis' /></center></td>
                        <td className='w-275'><span>Enuresis/Encopresis</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_15' name='txtEvidencedBy_15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbPsychosocial' name='cbPsychosocial' className='add-only' value='Psychosocial Stressors' /></center></td>
                        <td className='w-275'><span>Psychosocial Stressors</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_16' name='txtEvidencedBy_16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbPertinent' name='cbPertinent' className='add-only' value='Pertinent Health Issues/Medical History (include any allergies and food/drug reactions)' /></center></td>
                        <td className='w-275'><span>Pertinent Health Issues/Medical History (include any allergies and food/drug reactions)</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_17' name='txtEvidencedBy_17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-75'><center><input type='checkbox' id='cbAdjustment' name='cbAdjustment' className='add-only' value='Adjustment to disabilities and/or disorder' /></center></td>
                        <td className='w-275'><span>Adjustment to disabilities and/or disorder</span></td>
                        <td className='w-400'>
                            <input type='text' id='txtEvidencedBy_18' name='txtEvidencedBy_18' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Mental Status Summary</h3></center></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMSS_1' name='cbMSS_1' className='add-only' value='Not Clinically Indicated' /> Not Clinically Indicated</td>
                        <td className='w-250'><input type='checkbox' id='cbMSS_2' name='cbMSS_2' className='add-only' value='Unremarkable' /> Unremarkable</td>
                        <td className='w-250'><input type='checkbox' id='cbMSS_3' name='cbMSS_3' className='add-only' value='Remarkable' /> Remarkable</td>
                    </tr>
                </table>

                <p className='w-750'><b>NOTE: Record level of care next to abnormal findings. 1 = Mild, 2 = Moderate, 3 = Severe, X = Normal Finding</b></p>
                <span className='eleHeader'>General Observations</span>
                <table>
                    <tr>
                        <td className='w-750'><span><b>Appearance</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Well Groomed' /> Well Groomed</td>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Unkempt' /> Unkempt</td>
                        <td className='w-250'><input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Disheveled' /> Disheveled</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Build</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBuild_1' name='cbBuild_1' className='add-only' value='Average' /> Average</td>
                        <td className='w-250'><input type='checkbox' id='cbBuild_2' name='cbBuild_2' className='add-only' value='Thin' /> Thin</td>
                        <td className='w-250'><input type='checkbox' id='cbBuild_3' name='cbBuild_3' className='add-only' value='Overweight' /> Overweight</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Demeanor</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_1' name='cbDemeanor_1' className='add-only' value='Average' /> Average</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_2' name='cbDemeanor_2' className='add-only' value='Hostile' /> Hostile</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_3' name='cbDemeanor_3' className='add-only' value='Mistrustful' /> Mistrustful</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_4' name='cbDemeanor_4' className='add-only' value='Withdrawn' /> Withdrawn</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_5' name='cbDemeanor_5' className='add-only' value='Preoccupied' /> Preoccupied</td>
                        <td className='w-250'><input type='checkbox' id='cbDemeanor_6' name='cbDemeanor_6' className='add-only' value='Demanding' /> Demanding</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Eye Contact</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_1' name='cbEyeContact_1' className='add-only' value='Average' /> Average</td>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_2' name='cbEyeContact_2' className='add-only' value='Avoidant' /> Avoidant</td>
                        <td className='w-250'><input type='checkbox' id='cbEyeContact_3' name='cbEyeContact_3' className='add-only' value='Intense' /> Intense</td>

                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Activity</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbActivity_1' name='cbActivity_1' className='add-only' value='Average' /> Average</td>
                        <td className='w-250'><input type='checkbox' id='cbActivity_2' name='cbActivity_2' className='add-only' value='Agitated' /> Agitated</td>
                        <td className='w-250'><input type='checkbox' id='cbActivity_3' name='cbActivity_3' className='add-only' value='Slowed' /> Slowed</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Speech</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Clear' /> Clear</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Rapid' /> Rapid</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Pressured' /> Pressured</td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Impaired' /> Impaired</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Thought Content</span></p>


                <table>
                    <tr>
                        <td className='w-750'><span><b>Delusions</b> &nbsp;
                            <input type='checkbox' id='cbNR_1' name='cbNR_1' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_1' name='cbDelusions_1' className='add-only' value='Grandiose' /> Grandiose</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_2' name='cbDelusions_2' className='add-only' value='Persecutory' /> Persecutory</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_3' name='cbDelusions_3' className='add-only' value='Somatic' /> Somatic</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_4' name='cbDelusions_4' className='add-only' value='Bizarre' /> Bizarre</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_5' name='cbDelusions_5' className='add-only' value='Nihilistic' /> Nihilistic</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions_6' name='cbDelusions_6' className='add-only' value='Religious' /> Religious</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Other</b> &nbsp;
                            <input type='checkbox' id='cbNR_2' name='cbNR_2' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='Autistic' /> Autistic</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value='Obsessional' /> Obsessional</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_3' name='cbOther_3' className='add-only' value='Phobic' /> Phobic</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOther_4' name='cbOther_4' className='add-only' value='Guilty' /> Guilty</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_5' name='cbOther_5' className='add-only' value='IdeasReference' /> Ideas of Reference</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_6' name='cbOther_6' className='add-only' value='Preoccupied' /> Preoccupied</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOther_7' name='cbOther_7' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-250'><input type='checkbox' id='cbOther_8' name='cbOther_8' className='add-only' value='Other' /> Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Self Abuse</b> &nbsp;
                            <input type='checkbox' id='cbNR_3' name='cbNR_3' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_1' name='cbSelfAbuse_1' className='add-only' value='Suicidal' /> Suicidal (assess lethality if present):</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_2' name='cbSelfAbuse_2' className='add-only' value='Intent' /> Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_3' name='cbSelfAbuse_3' className='add-only' value='Plan' /> Plan</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSelfAbuse_4' name='cbSelfAbuse_4' className='add-only' value='SelfMutilization' /> Self Mutilization</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Aggressive</b> &nbsp;
                            <input type='checkbox' id='cbNR_4' name='cbNR_4' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_1' name='cbAggressive_1' className='add-only' value='Aggressive' /> Aggressive</td>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_2' name='cbAggressive_2' className='add-only' value='Intent' /> Intent</td>
                        <td className='w-250'><input type='checkbox' id='cbAggressive_3' name='cbAggressive_3' className='add-only' value='Plan' /> Plan</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Perception</span></p>

                <table>
                    <tr>
                        <td className='w-750'><span><b>Hallucinations</b> &nbsp;
                            <input type='checkbox' id='cbNR_5' name='cbNR_5' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_1' name='cbHallucinations_1' className='add-only' value='Auditory' /> Auditory</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_2' name='cbHallucinations_2' className='add-only' value='Visual' /> Visual</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_3' name='cbHallucinations_3' className='add-only' value='Olfactory' /> Olfactory</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_4' name='cbHallucinations_4' className='add-only' value='Gustatory' /> Gustatory</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations_5' name='cbHallucinations_5' className='add-only' value='Tactile' /> Tactile</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Other</b> &nbsp;
                            <input type='checkbox' id='cbNR_6' name='cbNR_6' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbOth_1' name='cbOth_1' className='add-only' value='Illusions' /> Illusions</td>
                        <td className='w-250'><input type='checkbox' id='cbOth_2' name='cbOth_2' className='add-only' value='Depersonalization' /> Depersonalization</td>
                        <td className='w-250'><input type='checkbox' id='cbOth_3' name='cbOth_3' className='add-only' value='Derealization' /> Derealization</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Thought Process </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_1' name='cbThoughtProcess_1' className='add-only' value='Logical' /> Logical</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_2' name='cbThoughtProcess_2' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_3' name='cbThoughtProcess_3' className='add-only' value='Tangential' /> Tangential</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_4' name='cbThoughtProcess_4' className='add-only' value='Loose' /> Loose</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_5' name='cbThoughtProcess_5' className='add-only' value='Racing' /> Racing</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_6' name='cbThoughtProcess_6' className='add-only' value='Incoherent' /> Incoherent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_7' name='cbThoughtProcess_7' className='add-only' value='Concrete' /> Concrete</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_8' name='cbThoughtProcess_8' className='add-only' value='Blocked' /> Blocked</td>
                        <td className='w-250'><input type='checkbox' id='cbThoughtProcess_9' name='cbThoughtProcess_9' className='add-only' value='Flight of Ideas' /> Flight of Ideas</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Mood</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Depressed' /> Depressed</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Anxious' /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Angry' /> Angry</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-250'><input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Irritable' /> Irritable</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Affect</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Full' /> Full</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Constricted' /> Constricted</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Flat' /> Flat</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-250'><input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Labile' /> Labile</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Behavior</span></p>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_1' name='cbBehavior_1' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_2' name='cbBehavior_2' className='add-only' value='Resistant' /> Resistant</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_3' name='cbBehavior_3' className='add-only' value='Agitated' /> Agitated</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_4' name='cbBehavior_4' className='add-only' value='Impulsive' /> Impulsive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_5' name='cbBehavior_5' className='add-only' value='Over Sedated' /> Over Sedated</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_6' name='cbBehavior_6' className='add-only' value='Assaultive' /> Assaultive</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_7' name='cbBehavior_7' className='add-only' value='Aggressive' /> Aggressive</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_8' name='cbBehavior_8' className='add-only' value='Hyperactive' /> Hyperactive</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_9' name='cbBehavior_9' className='add-only' value='Restless' /> Restless</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_10' name='cbBehavior_10' className='add-only' value='Loss of Interests' /> Loss of Interests</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_11' name='cbBehavior_11' className='add-only' value='Anhedonia' /> Anhedonia</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_12' name='cbBehavior_12' className='add-only' value='Akasthisia' /> Akasthisia</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_13' name='cbBehavior_13' className='add-only' value='Withdrawn' /> Withdrawn</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_14' name='cbBehavior_14' className='add-only' value='Dystonia' /> Dystonia</td>
                        <td className='w-187'><input type='checkbox' id='cbBehavior_15' name='cbBehavior_15' className='add-only' value='Tardive Dyskinesia' /> Tardive Dyskinesia</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Cognition</span></p>
                <table>
                    <tr>
                        <td className='w-750'><span><b>Impairment of:</b> &nbsp;
                            <input type='checkbox' id='cbNR_7' name='cbNR_7' className='add-only' value='NoneReported' /> None Reported
                        </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_1' name='cbImpairment_1' className='add-only' value='Orientation' /> Orientation</td>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_2' name='cbImpairment_2' className='add-only' value='Memory' /> Memory</td>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_3' name='cbImpairment_3' className='add-only' value='Attention/Concentration' /> Attention/Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbImpairment_4' name='cbImpairment_4' className='add-only' value='Ability to Abstract' /> Ability to Abstract</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Intelligence Estimate</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_1' name='cbIntelligence_1' className='add-only' value='MR' /> MR</td>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_2' name='cbIntelligence_2' className='add-only' value='Borderline' /> Borderline</td>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_3' name='cbIntelligence_3' className='add-only' value='Average' /> Average</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_4' name='cbIntelligence_4' className='add-only' value='Above Average' /> Above Average</td>
                        <td className='w-250'><input type='checkbox' id='cbIntelligence_5' name='cbIntelligence_5' className='add-only' value='Developmental Delays' /> Developmental Delays</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Insight/Judgment</span></p>
                <table>
                    <tr>
                        <td className='w-750'><span><b>Insight</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInsight_1' name='cbInsight_1' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_2' name='cbInsight_2' className='add-only' value='BlamesOthers' /> Blames others</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_3' name='cbInsight_3' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'><input type='checkbox' id='cbInsight_4' name='cbInsight_4' className='add-only' value='Fair' /> Fair</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInsight_5' name='cbInsight_5' className='add-only' value='DeniesMinimizesProblem' /> Denies/Minimizes Problem(s)</td>

                    </tr>
                    <tr>
                        <td className='750'><input type='checkbox' id='cbInsight_6' name='cbInsight_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtInsight' name='txtInsight' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><b>Judgment</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_1' name='cbJudgment_1' className='add-only' value='Age Appropriate' /> Age Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_2' name='cbJudgment_2' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_3' name='cbJudgment_3' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_4' name='cbJudgment_4' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbJudgment_5' name='cbJudgment_5' className='add-only' value='Seriously Impaired' /> Seriously Impaired</td>

                    </tr>
                    <tr>
                        <td className='750'><input type='checkbox' id='cbJudgment_6' name='cbJudgment_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtJudgment' name='txtJudgment' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Suicide/Homicide Risk Potential</h3></center></p>
                <span className='eleHeader'>Past attempts to Harm Self or Others</span>
                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPastAttempts_1' name='cbPastAttempts_1' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-250'><input type='checkbox' id='cbPastAttempts_2' name='cbPastAttempts_2' className='add-only' value='Self' /> Self</td>
                        <td className='w-250'><input type='checkbox' id='cbPastAttempts_3' name='cbPastAttempts_3' className='add-only' value='Others' /> Others</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea id='txtComment_1' name='txtComment_1' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Current Risk of Harm to Self </span>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRisk_1' name='cbCurrentRisk_1' className='add-only' value='None Noted' /> None Noted</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRisk_2' name='cbCurrentRisk_2' className='add-only' value='Low' /> Low</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRisk_3' name='cbCurrentRisk_3' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRisk_4' name='cbCurrentRisk_4' className='add-only' value='High' /> High</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea id='txtComment_2' name='txtComment_2' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Current Risk of Harm to Others</span>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRiskOthers_1' name='cbCurrentRiskOthers_1' className='add-only' value='None Noted' /> None Noted</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRiskOthers_2' name='cbCurrentRiskOthers_2' className='add-only' value='Low' /> Low</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRiskOthers_3' name='cbCurrentRiskOthers_3' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-187'><input type='checkbox' id='cbCurrentRiskOthers_4' name='cbCurrentRiskOthers_4' className='add-only' value='High' /> High</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comment</span>
                    <textarea id='txtComment_3' name='txtComment_3' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h3>Clinical/Interpretative Summary</h3></center></p>
                <span className='eleHeader'>This Clinical/Interpretative Summary is Based Upon Information Provided By </span>
                <span className='small'>(check all that apply)</span>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_1' name='cbInterpretative_1' className='add-only' value='Client' /> Client</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_2' name='cbInterpretative_2' className='add-only' value='Parent(s)' /> Parent(s)</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_3' name='cbInterpretative_3' className='add-only' value='Guardian(s)' /> Guardian(s)</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_4' name='cbInterpretative_4' className='add-only' value='Family/Friend' /> Family/Friend</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_5' name='cbInterpretative_5' className='add-only' value='Physician' /> Physician</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_6' name='cbInterpretative_6' className='add-only' value='Records' /> Records</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_7' name='cbInterpretative_7' className='add-only' value='Law Enforcement' /> Law Enforcement</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_8' name='cbInterpretative_8' className='add-only' value='Service Provider' /> Service Provider</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_9' name='cbInterpretative_9' className='add-only' value='School Personnel' /> School Personnel</td>
                        <td className='w-187'><input type='checkbox' id='cbInterpretative_10' name='cbInterpretative_10' className='add-only' value='Other' /> Other</td>
                    </tr>
                </table>

                <span className='eleHeader'>Child IPRS Target Population Eligibility</span>
                <span className='small'>(check one box of primary population that applies)</span>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_1' name='cbEligibility_1' className='add-only' value='SeriouslyEmotionallyDisturbedChild' /> CMSED-CMH Seriously Emotionally Disturbed Child </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_2' name='cbEligibility_2' className='add-only' value='CrisisServices' /> CMCS-CMH Crisis Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_3' name='cbEligibility_3' className='add-only' value='DevelopmentallyDisability' /> CDSN-CDD Developmentally Disability</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_4' name='cbEligibility_4' className='add-only' value='EarlyChildhoodDisorder' /> CMECD-CMH Early Childhood Disorder</td>


                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_5' name='cbEligibility_5' className='add-only' value='AssessmentOnly' /> CDAO-CDD Assessment Only</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_6' name='cbEligibility_6' className='add-only' value='CrisisServices' /> CDCS-CDD Crisis Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_7' name='cbEligibility_7' className='add-only' value='AssessmentOnly' /> CMAO-CMH Assessment Only</td>


                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_8' name='cbEligibility_8' className='add-only' value='ChildWithSubstanceAbuseDisorder' /> CSSAD-CSA Child with Substance Abuse Disorder</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_9' name='cbEligibility_9' className='add-only' value='ChildTheMajorsSaJjProgram' /> CSMAJ-CSA Child in the MAJORS SA/JJ Program</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_10' name='cbEligibility_10' className='add-only' value='AssessmentOnly' /> CSAO-CSA Assessment Only</td>


                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_11' name='cbEligibility_11' className='add-only' value='CrisisServices' /> CSCS-CSA Crisis Services</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_12' name='cbEligibility_12' className='add-only' value='VeteranFamilyUnderAge18' /> CMVET-Veteran and Family (under age 18)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbEligibility_13' name='cbEligibility_13' className='add-only' value='NoIprsTargetPopulationNotEligibleForFunding)' /> No IPRS Target Population (Not eligible for IPRS funding)</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Clinical Impression </span>
                    <span className='small'>{`(Include consumer’s level of readiness and motivation to engage in services) Also include strengths, protective factors, risk of harm, functional status, co-morbidity, recovery environment/history and treatment.`}</span>
                    <textarea id='txtClinicalImpression' name='txtClinicalImpression' className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Diagnosis:</span>
                <table>
                    <tr>
                        <td className='w-50'><span><b>Check Primary</b></span></td>
                        <td className='w-150'><span><b>DSM 5 Code</b></span></td>
                        <td className='w-150'><span><b>ICD 10 Code</b></span></td>
                        <td className='w-400'><span><b>Narrative Description</b></span></td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='checkbox' id='cbCheckPrimary_1' name='cbCheckPrimary_1' className='add-only' value='CheckPrimary' /></td>
                        <td className='w-150'><input type='text' id='txtDSMCode_1' name='txtDSMCode_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtICDCode_1' name='txtICDCode_1' className='add-only' /></td>
                        <td className='w-400'>
                            <input type='text' id='txtNarrative_1' name='txtNarrative_1' aria-multiline='true' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='checkbox' id='cbCheckPrimary_2' name='cbCheckPrimary_2' className='add-only' value='CheckPrimary' /></td>
                        <td className='w-150'><input type='text' id='txtDSMCode_2' name='txtDSMCode_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtICDCode_2' name='txtICDCode_2' className='add-only' /></td>
                        <td className='w-400'><input type='text' id='txtNarrative_2' name='txtNarrative_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='checkbox' id='cbCheckPrimary_3' name='cbCheckPrimary_3' className='add-only' value='CheckPrimary' /></td>
                        <td className='w-150'><input type='text' id='txtDSMCode_3' name='txtDSMCode_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtICDCode_3' name='txtICDCode_3' className='add-only' /></td>
                        <td className='w-400'><input type='text' id='txtNarrative_3' name='txtNarrative_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='checkbox' id='cbCheckPrimary_4' name='cbCheckPrimary_4' className='add-only' value='CheckPrimary' /></td>
                        <td className='w-150'><input type='text' id='txtDSMCode_4' name='txtDSMCode_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtICDCode_4' name='txtICDCode_4' className='add-only' /></td>
                        <td className='w-400'><input type='text' id='txtNarrative_4' name='txtNarrative_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'><input type='checkbox' id='cbCheckPrimary_5' name='cbCheckPrimary_5' className='add-only' value='CheckPrimary' /></td>
                        <td className='w-150'><input type='text' id='txtDSMCode_5' name='txtDSMCode_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtICDCode_5' name='txtICDCode_5' className='add-only' /></td>
                        <td className='w-400'><input type='text' id='txtNarrative_5' name='txtNarrative_5' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Add V codes associated</span></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <b>Problems with primary support group:</b></td>
                        <td className='w-375'><input type='radio' id='rbPrimarySupport_Yes' name='rbPrimarySupport' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPrimarySupport_No' name='rbPrimarySupport' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Problems related to the social environment:</b></td>
                        <td className='w-375'><input type='radio' id='rbProblems_Yes' name='rbProblems' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbProblems_No' name='rbProblems' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Educational problems:</b></td>
                        <td className='w-375'><input type='radio' id='rbEducationalProblems_Yes' name='rbEducationalProblems' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEducationalProblems_No' name='rbEducationalProblems' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Occupational problems:</b></td>
                        <td className='w-375'><input type='radio' id='rbOccupational_Yes' name='rbOccupational' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbOccupational_No' name='rbOccupational' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Housing problems:</b></td>
                        <td className='w-375'><input type='radio' id='rbHousing_Yes' name='rbHousing' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHousing_No' name='rbHousing' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Economic problems:</b></td>
                        <td className='w-375'><input type='radio' id='rbEconomic_Yes' name='rbEconomic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEconomic_No' name='rbEconomic' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Problems with access to health care services:</b></td>
                        <td className='w-375'><input type='radio' id='rbServices_Yes' name='rbServices' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbServices_No' name='rbServices' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Problems with interaction with the legal system/crime:</b></td>
                        <td className='w-375'><input type='radio' id='rbInteraction_Yes' name='rbInteraction' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInteraction_No' name='rbInteraction' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <b>Other psychosocial and environmental problems:</b></td>
                        <td className='w-375'><input type='radio' id='rbPsychosocial_Yes' name='rbInteraction' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPsychosocial_No' name='rbInteraction' className='add-only' value='No' /> No</td>
                    </tr>
                </table>

                <span className='eleHeader'>Treatment Recommendations to be addressed in Person Centered Plan</span>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_1' name='cbRecommendations_1' className='add-only' value='MhIndividualTherapy' /> MH Individual Therapy</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_2' name='cbRecommendations_2' className='add-only' value='MedicationMonitoring' /> Medication Monitoring</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_3' name='cbRecommendations_3' className='add-only' value='MobileCrisisManagementServices' /> Mobile Crisis Management Services</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_4' name='cbRecommendations_4' className='add-only' value='MhGroupTherapy' /> MH Group Therapy</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_5' name='cbRecommendations_5' className='add-only' value='PsychiatricEvaluation' /> Psychiatric Evaluation</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_6' name='cbRecommendations_6' className='add-only' value='Shelter' /> Shelter</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_7' name='cbRecommendations_7' className='add-only' value='MhFamilyTherapy' /> MH Family Therapy</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_8' name='cbRecommendations_8' className='add-only' value='PsychologicalEvaluation' /> Psychological Evaluation</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_9' name='cbRecommendations_9' className='add-only' value='Housing' /> Housing</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_10' name='cbRecommendations_10' className='add-only' value='IntensiveInHomeServices' /> Intensive In-home Services</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_11' name='cbRecommendations_11' className='add-only' value='ResidentialTreatmentLevel' /> Residential Treatment (Level III/IV)</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_12' name='cbRecommendations_12' className='add-only' value='MedicalNeurologicalEval' /> Medical/Neurological Eval.</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_13' name='cbRecommendations_13' className='add-only' value='CommunitySupportTeam' /> Community Support Team</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_14' name='cbRecommendations_14' className='add-only' value='PsychosocialRehabilitation' /> Psychosocial Rehabilitation</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_15' name='cbRecommendations_15' className='add-only' value='Respite' /> Respite</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_16' name='cbRecommendations_16' className='add-only' value='VocationalRehabilitation' /> Vocational Rehabilitation</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_17' name='cbRecommendations_17' className='add-only' value='SaOutpatientServices' /> SA Outpatient Services </td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_18' name='cbRecommendations_18' className='add-only' value='VeteranAffairs' /> Veteran Affairs</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_19' name='cbRecommendations_19' className='add-only' value='FaithBasedReferral' /> Faith Based Referral</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_20' name='cbRecommendations_20' className='add-only' value='SaIntensiveOutpatientServices' /> SA Intensive Outpatient Services (SAIOP) </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_21' name='cbRecommendations_21' className='add-only' value='DepartmentSocialServices' /> Department of Social Services</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_22' name='cbRecommendations_22' className='add-only' value='FoodBank' /> Food Bank </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_23' name='cbRecommendations_23' className='add-only' value='SaPartialHospitalizationServices' /> SA Partial Hospitalization Services (SACOT) </td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_24' name='cbRecommendations_24' className='add-only' value='LegalServices' /> Legal Services</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_25' name='cbRecommendations_25' className='add-only' value='FamilyPsychoEd' /> Family Psycho-Ed </td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_26' name='cbRecommendations_26' className='add-only' value='SaClinicallyManagedPopulationSpecificHighIntensityResidential' /> SA Clinically Managed Population-Specific, High-Intensity Residential services </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_27' name='cbRecommendations_27' className='add-only' value='AaNa' /> AA/NA</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_28' name='cbRecommendations_28' className='add-only' value='WellnessIllnessManagementRecovery' /> Wellness/Illness Management Recovery </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_29' name='cbRecommendations_29' className='add-only' value='SaClinicallyManageHighIntensityResidentialServicesAdultCriteria' /> SA Clinically Manage High-Intensity Residential Services (Adult Criteria) </td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_30' name='cbRecommendations_30' className='add-only' value='InterpreterServices' /> Interpreter Services</td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_31' name='cbRecommendations_31' className='add-only' value='SocialSecurityAdministration' /> Social Security Administration</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_32' name='cbRecommendations_32' className='add-only' value='SaMedicallyMonitoredIntensiveInpatientServicesAdultCriteria' /> SA Medically Monitored Intensive Inpatient Services (Adult Criteria) </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRecommendations_33' name='cbRecommendations_33' className='add-only' value='Nutritional' /> Nutritional</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRecommendations_34' name='cbRecommendations_34' className='add-only' value='Other' /> Other : &nbsp;
                            <input type='text' id='txtRecommendations_34' name='txtRecommendations_34' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_35' name='cbRecommendations_35' className='add-only' value='SaMedicallyMonitoredManagedIntensiveInpatientServices' /> SA Medically Monitored/Managed Intensive Inpatient Services</td>
                        <td className='w-375'><input type='checkbox' id='cbRecommendations_36' name='cbRecommendations_36' className='add-only' value='AuditoryVisualAssessment' /> Auditory/Visual Assessment</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRecommendations_37' name='cbRecommendations_37' className='add-only' value='Other' /> Other : &nbsp;
                            <input type='text' id='txtRecommendations_37' name='txtRecommendations_37' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbRecommendations_38' name='cbRecommendations_38' className='add-only' value='SaMedicallyManagedIntensiveInpatientServices' /> SA Medically Managed Intensive Inpatient  Services</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>{`Entrance Criteria – Intensive In-Home Services – Premier Behavioral Services
                    A recipient is eligible for this service when`}</h4></center></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`A. There is an MH/SA diagnosis (as defined by the DSM-V or it successors), other than a sole diagnosis of 
                                developmental disability.`}</span> <br />
                            <input type='checkbox' id='cbDD_1' name='cbDD_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbDD_2' name='cbDD_2' className='add-only' value='No Met' /> No Met</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_1' name='txtExplain_1' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>AND</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`B. Based on the current comprehensive clinical assessment, this service was indicated and 
                                outpatient treatment services were considered or previously attempted, but were found to be inappropriate or not effective.`}</span> <br />
                            <input type='checkbox' id='cbCCA_1' name='cbCCA_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbCCA_2' name='cbCCA_2' className='add-only' value='No Met' /> No Met</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_2' name='txtExplain_2' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>AND</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`C. The youth has current or past history of symptoms or behaviors indicating the need or a 
                                crisis intervention as evidenced by suicidal/homicidal ideation, physical aggression toward others, 
                                self-injurious behavior, serious risk taking behavior (running away, sexual aggression, sexually reactive 
                                behavior, or substance use).`}</span> <br />
                            <input type='checkbox' id='cbSymptoms_1' name='cbSymptoms_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbSymptoms_2' name='cbSymptoms_2' className='add-only' value='No Met' /> No Met</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_3' name='txtExplain_3' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>AND</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`D. The youth’s symptoms and behavior are unmanageable at home, school, or in other community settings due 
                                to the deterioration of his or her mental health or substance abuse condition, requiring intensive, coordinated
                                 clinical interventions.`}</span> <br />
                            <input type='checkbox' id='cbUnmanageable_1' name='cbUnmanageable_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbUnmanageable_2' name='cbUnmanageable_2' className='add-only' value='No Met' /> No Met</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_4' name='txtExplain_4' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>AND</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`E. The youth is at imminent risk of out-of home placement based on the child or adolescent’s 
                                current mental health or substance abuse clinical symptomatology, or is currently in an out-of-home 
                                placement and return home is imminent.`}</span><br />
                            <input type='checkbox' id='cbImminent_1' name='cbImminent_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbImminent_2' name='cbImminent_2' className='add-only' value='No Met' /> No Met
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_5' name='txtExplain_5' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>AND</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`F. There is no evidence to support that alternative interventions would be equally or more effective, base on North Carolina 
                                Community Practice Standards (Best Practice Guidelines of the American Academy of Child and Adolescent Psychiatry, American 
                                Psychiatric Association, American Society of Addition Medicine).`}</span> <br />
                            <input type='checkbox' id='cbAlternative_1' name='cbAlternative_1' className='add-only' value='Met' /> Met &nbsp;
                            <input type='checkbox' id='cbAlternative_2' name='cbAlternative_2' className='add-only' value='No Met' /> No Met
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain: </span>
                    <textarea id='txtExplain_6' name='txtExplain_6' className='add-only'></textarea>
                </p>


                <p className='w-750'><center><h3>Assessment Inter Disciplinary Team Progress Note</h3></center></p>
                <p className='w-750'><b>{`The team discussed the consumer’s Assessment, Diagnosis and Treatment Plan.`}  </b></p>
                <table>
                    <tr>
                        <td>
                            <span><b>Any changes in assessment:</b></span> &nbsp;
                            <input type='radio' id='rbAssessment_Yes' name='rbAssessment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAssessment_No' name='rbAssessment' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes please explain </span>
                    <textarea id='txtPleaseExplain' name='txtPleaseExplain' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature Qualified Professional:</td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature of License Professional:</td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>MD License Professional:</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Signatures</h3></center></p>

                <p className='w-750'><b>I acknowledge that all documentation contained in this clinical assessment was information provided by the above listed client on this date.</b></p>


                <table>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Clinical Director Signature/Credentials</td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>QM Director Signature/Credentials</td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Medical Director Signature/Credentials</td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Qualified Professional Signature/Credentials</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}  
